import { useContext } from 'react'
import * as Config from '../../../src/public/external-links'
import Conditional from '../common/Conditional'
import WorkplaceQuizContext from './context/WorkplaceQuizContext'
export interface IWorkplaceQuizSummaryButtonsProps {
  startQuiz: (id: number) => void
}
const WorkplaceQuizSummaryButtons = (
  props: IWorkplaceQuizSummaryButtonsProps
) => {
  const context = useContext(WorkplaceQuizContext)

  const onKeyPressReturnHome = async (event) => {
    if (event.keyCode === 13) {
      props.startQuiz(0)
    }
  }

  return (
    <>
      <div className="navButtons">
        <a
          href={`${Config.WORKPLACE_BASIC_QUIZ_SURVEY_LINK}`}
          target="_blank"
          className="button is-primary"
          rel="noreferrer"
        >
          Complete survey
        </a>
        <Conditional if={context.allQuizCompleted()}>
          <a
            target="_blank"
            className="button is-primary document pdf"
            href="public/Workplace-Basics-Certificate.pdf"
            rel="noreferrer"
            aria-label="view certificate"
          >
            View certificate
          </a>
        </Conditional>
        <a
          className="button is-secondary"
          onClick={() => props.startQuiz(0)}
          role="button"
          tabIndex={0}
          onKeyDown={onKeyPressReturnHome}
        >
          Return Home
        </a>
      </div>
    </>
  )
}
export default WorkplaceQuizSummaryButtons
